
const HeroBanner = {
  init: function (element) {
    const _ = this
    // only init if banner has video
    const hasVideo = element.querySelectorAll('.hero-banner__video').length > 0
    if (!hasVideo) return

    const playButton = element.querySelector('.hero-banner__button-play')
    const pauseButton = element.querySelector('.hero-banner__button-pause')
    const video = element.querySelector('.hero-banner__video iframe')
    console.log(video)

    playButton.addEventListener('click', (e) => {
      _.video_toggle(video, 'play')
      element.classList.remove('paused')
    })

    pauseButton.addEventListener('click', (e) => {
      _.video_toggle(video, 'pause')
      element.classList.add('paused')
    })
  },

  video_toggle: (video, action) => {
    const data = { method: action }
    const url = video.src.split('?')[0]

    if (url !== undefined) {
      video.contentWindow.postMessage(JSON.stringify(data), url)
    }
  }
}

export default HeroBanner
